import { useQuery } from '@tanstack/react-query';
import { candidatesApi } from '../candidatesApi';
import { candidateQueryKeys } from '../queryKeys';

export const useGetCandidateStatuses = () => {
  return useQuery({
    queryKey: candidateQueryKeys.statuses,
    queryFn: () => candidatesApi.getStatuses(),
  });
};
